import { render, staticRenderFns } from "./MailMagazineCheckList.vue?vue&type=template&id=5f87d980&scoped=true&"
import script from "./MailMagazineCheckList.vue?vue&type=script&lang=ts&"
export * from "./MailMagazineCheckList.vue?vue&type=script&lang=ts&"
import style0 from "./MailMagazineCheckList.vue?vue&type=style&index=0&id=5f87d980&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f87d980",
  null
  
)

export default component.exports